import { render } from "./PatientAccountability.vue?vue&type=template&id=7c2af2df&scoped=true"
import script from "./PatientAccountability.vue?vue&type=script&lang=js"
export * from "./PatientAccountability.vue?vue&type=script&lang=js"

import "./PatientAccountability.vue?vue&type=style&index=0&id=7c2af2df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2af2df"]])

export default __exports__